//import React, { useState, useEffect } from 'react';
import React, { useState, useEffect, useRef } from 'react';
import { AppBar, Toolbar, IconButton, Menu, MenuItem, Typography, Dialog, DialogTitle, DialogContent, TextField, } from '@mui/material';
//import { AccountCircle, ImportContacts, ExitToApp } from '@mui/icons-material';
import { AccountCircle, Search, Public } from '@mui/icons-material';
import { useLocation, useNavigate } from 'react-router-dom';
//import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
//import i18n from '../i18n';


const MenuComponent = ({ socket, onLogout, selectedDiscussion, setSelectedDiscussion, startVideoCall, setCallInProgress, callInProgress }) => {

  const [anchorEl, setAnchorEl] = useState(null);
  const navigate = useNavigate();
const location = useLocation();

  const [openSearch, setOpenSearch] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");


const { t, i18n } = useTranslation();
const currentLang = i18n.language;

 const handleSearchOpen = () => setOpenSearch(true);
  const handleSearchClose = () => setOpenSearch(false);

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    setOpenSearch(false);
    navigate(`/public?search=${encodeURIComponent(searchQuery)}`);
  };


const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';
  const token = localStorage.getItem('token');

useEffect(() => {
  if (!socket) return;

  const handleStatus = (data) => {
    //console.log("📡 userStatusChanged :", data);
  };

  socket.on("userStatusChanged", handleStatus);
  return () => socket.off("userStatusChanged", handleStatus);
}, [socket]);

 


 
  return (
    <AppBar position="static"  style={{ width: '100%', boxShadow: 'none', background: 'transparent', height: '50px', display: 'none' }}>
      <Toolbar sx={{ display: "flex", justifyContent: "right", alignItems: "center", display: 'none' 
    }}>

         

{/* 🌍 Icône "Public / Groupes" */}
      <IconButton color="#1976d2" style={{color: '#BABABA', paddingTop: '0', display: 'none'  }} onClick={() => navigate("/public")} title="Groupes publics">
        <Public />
      </IconButton>

      


	  
      </Toolbar>

    </AppBar>
  );
};

export default MenuComponent;
